import {Pipe, PipeTransform} from '@angular/core'

@Pipe({name: 'additionPercentage'})
export class AdditionPercentagePipe implements PipeTransform {
  transform(value: any, percentage?: any): string | number {


	let price = parseFloat(value)

      	let x =  percentage ? (price+((price / 100)* percentage)) : price

      if( x % 1 !== 0){
		  return x.toFixed(2)
               }else{
		  return x
		}
 

  }
}
